const baseUrl = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:3001";

let csrfToken: string | null = null;
async function csrf() {
  if (csrfToken) return csrfToken;
  const response = await fetch(`${baseUrl}/api/csrf-token`, {
    credentials: "include",
  });
  csrfToken = (await response.json()).csrfToken;
  return csrfToken!;
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export async function api(path: string, init: RequestInit = {}) {
  const headers = new Headers(init.headers);
  if (init.method && !["GET", "HEAD"].includes(init.method))
    headers.set("X-CSRF-Token", await csrf());
  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers,
    credentials: "include",
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new ApiError(
      body.error?.message ?? body.message ?? "Request failed",
      response.status,
    );
  }
  return response;
}
